import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/44_card_back_chinese_wall/44_card_back_chinese_wall"
 * Contains 1 texture(s)
 */
export class CardsBacks44CardBackChineseWallAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/44_card_back_chinese_wall/44_card_back_chinese_wall';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '44_chinese_wall.png'
    ] as const;
}
